"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AnalyticsContext", {
  enumerable: true,
  get: function get() {
    return _analytics.AnalyticsContext;
  }
});
Object.defineProperty(exports, "AnalyticsLocationConsumer", {
  enumerable: true,
  get: function get() {
    return _analytics.AnalyticsLocationConsumer;
  }
});
Object.defineProperty(exports, "AnalyticsLocationProvider", {
  enumerable: true,
  get: function get() {
    return _analytics.AnalyticsLocationProvider;
  }
});
Object.defineProperty(exports, "AnalyticsProvider", {
  enumerable: true,
  get: function get() {
    return _analytics.AnalyticsProvider;
  }
});
Object.defineProperty(exports, "PageTracking", {
  enumerable: true,
  get: function get() {
    return _analytics.PageTracking;
  }
});
Object.defineProperty(exports, "trackEvent", {
  enumerable: true,
  get: function get() {
    return _analytics.trackEvent;
  }
});
Object.defineProperty(exports, "setLocation", {
  enumerable: true,
  get: function get() {
    return _analytics.setLocation;
  }
});
Object.defineProperty(exports, "getTrackingQueryString", {
  enumerable: true,
  get: function get() {
    return _analytics.getTrackingQueryString;
  }
});
Object.defineProperty(exports, "getAnalyticsDataAttributes", {
  enumerable: true,
  get: function get() {
    return _dataLayer.getAnalyticsDataAttributes;
  }
});
Object.defineProperty(exports, "getInternalTrafficSource", {
  enumerable: true,
  get: function get() {
    return _dataLayer.getInternalTrafficSource;
  }
});
Object.defineProperty(exports, "initTealium", {
  enumerable: true,
  get: function get() {
    return _initTealium.initTealium;
  }
});
Object.defineProperty(exports, "initTealiumSsr", {
  enumerable: true,
  get: function get() {
    return _initTealium.initTealiumSsr;
  }
});
Object.defineProperty(exports, "schema", {
  enumerable: true,
  get: function get() {
    return _schema.schema;
  }
});
var _analytics = require("./analytics");
var _dataLayer = require("./data-layer");
var _initTealium = require("./init-tealium");
var _schema = require("./schema");